import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useIsFetching } from 'react-query';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import './LoadingBar.css';

// Configure nprogress
NProgress.configure({
  showSpinner: false,      // No spinner, just bar
  trickleSpeed: 200,       // Smooth animation
  minimum: 0.08,           // Start at 8%
  easing: 'ease',          // CSS easing
  speed: 300,              // Complete in 300ms
});

export const LoadingBar = () => {
  const location = useLocation();
  const isFetching = useIsFetching();
  
  const isLoading = isFetching > 0;

  useEffect(() => {
    if (isLoading) {
      NProgress.start();
    } else {
      NProgress.done();
    }

    return () => {
      NProgress.done();
    };
  }, [isLoading, location]);

  return (
    <div 
      role="status" 
      aria-live="polite" 
      className="sr-only"
      aria-label={isLoading ? 'Loading page content' : ''}
    >
      {isLoading ? 'Loading page content' : ''}
    </div>
  );
};
